import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { SalesMonitoringService } from 'src/app/assabil-sales/services/sales-monitoring-service';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Visit } from 'src/app/assabil-kernel/models/entities/master-data/visit-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';

@Component({
  selector: 'role-kpis-widget',
  templateUrl: './role-kpis-widget.component.html',
  styleUrls: ['./role-kpis-widget.component.scss']
})


export class RoleKpisWidgetComponent implements OnInit {
  
  @Input() role                 : Role;
  @Input() clickedRoleContainer : Role[];

  @Output() onRoleClicked   = new EventEmitter<any>();
  @Output() onKpiClicked    = new EventEmitter<string>();
  

  buttonColor: string = '#f1eeee';
  visits : Visit[];
  clickNumber : number=0;

  ngOnInit(){}

  constructor( 
    public    leanUtilsService    : LeanUtilsService,
    protected salesMonitoringService : SalesMonitoringService
   ) {
  }


  roleClicked(passTrough : boolean){
    if (! passTrough) {
      this.clickedRoleContainer[0] = this.role;
    }
    this.onRoleClicked.emit(null);  
  }

  kpiClicked(roleAndIndex : string){
    this.onKpiClicked.emit(roleAndIndex);  
  }

/*   getPersonName(person : Person) : string{
    let name : string = "";
    if ( (person.firstName) && (person.firstName.trim() != '.')) name = person.firstName + " ";
    if ( (person.lastName) && (person.lastName.trim() != '.')) name += person.lastName;
    return name;
  } */

}
